import { fiberColors } from '../constants/fiberColors'

export const getTubeColor = (strandId, cableSize) => {
  if (cableSize === 4) return 'NA' // 4 strand cables don't have a tube

  const id = strandId % 12 === 0 ? strandId / 12 : Math.floor(strandId / 12) + 1

  return fiberColors.find(color => color.id === id).color
}
